import { Api } from "./Api";

const ENPOINTS = {
  Paiement: "paiements",
};

const getAll = (signal) => {
  return Api.get(ENPOINTS.Paiement, signal);
};

const getById = (id, signal) => {
  return Api.get(`${ENPOINTS.Paiement}/${id}`, signal);
};

const create = (payload, signal) => {
  return Api.post(`user/${ENPOINTS.Paiement}`, payload, signal);
};

const creates = (token, payload, signal) => {
  return Api.posts(`user/${ENPOINTS.Paiement}`, token, payload, signal);
};

const update = (id, payload, signal) => {
  return Api.put(`${ENPOINTS.Paiement}/${id}`, payload, signal);
};
const destroy = (id, signal) => {
  return Api.erase(`${ENPOINTS.Paiement}/${id}`, signal);
};

export const PaiementService = {
  getAll,
  getById,
  create,
  creates,
  update,
  destroy,
};
